import * as Sentry from '@sentry/react-native'

export const navigationIntegration = Sentry.reactNavigationIntegration({
    enableTimeToInitialDisplay: true,
})

Sentry.init({
    enabled: process.env.EXPO_PUBLIC_SENTRY_ENABLED === 'true',
    dsn: process.env.EXPO_PUBLIC_SENTRY_DSN,
    tracesSampleRate: 1,
    debug: false,
    normalizeDepth: 12,
    integrations: [navigationIntegration],
    enableNativeFramesTracking: true,
})
